(function () {
  function place(section) {
    var hint = section.querySelector('.section-swipe-hint');
    var slider = section.querySelector('.slider'); // Dawn's scrollable product row
    if (!hint || !slider) return;
    hint.style.top = (slider.offsetTop + slider.offsetHeight / 2) + 'px';
  }

  function init(root) {
    (root || document).querySelectorAll('.card-swipe-section').forEach(function (section) {
      var hint = section.querySelector('.section-swipe-hint');
      var slider = section.querySelector('.slider');
      if (!hint || !slider) return;

      place(section);

      if (!section.dataset.swipeHintBound) {
        section.dataset.swipeHintBound = 'true';
        var hide = function () {
          section.classList.add('is-swiped');
          slider.removeEventListener('scroll', hide);
          slider.removeEventListener('touchstart', hide);
        };
        slider.addEventListener('scroll', hide, { passive: true });
        slider.addEventListener('touchstart', hide, { passive: true });
      }
    });
  }

  function reposition() {
    document.querySelectorAll('.card-swipe-section').forEach(place);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  window.addEventListener('load', reposition);
  window.addEventListener('resize', reposition);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();